const commonEn = {
   "restaurant": "Restaurant",
   "restaurant_not_found": "The restaurant is not available",
   "table_not_available": "Orders cannot be placed at this table",
   "note": "Note",
   "order": "Order",
   "internal_error": "Request unsuccessful. The server responded with the following error: ",
   "no_results": "No results",
   "cancel": "Cancel",
   "save": "Save",
   "back": "Back",
   "search": "Search",
   "search_for_file_names": "Search for file names",
   "delete": "Delete",
   "search_by_restaurant": "Keresés étterem szerint",
   "available": "Available",
   "unavailable": "Unavailable",
   "name": "Name",
   "status": "Status",
   "description": "Description",
   "price": "Price",
   "add": "Add",
   "phone": "Phone",
   "internal_server_error": "Internal server error",
   "remove_all": "Összes törlése",
   "settings": "Settings",
   "restaurant_name": "Restaurant name",
   "reservation_link": "Reservation link",
   "reservation_link_tooltip": "Only Reservours reservation system links are allowed",
   "add_user": "Add user",
   "add_user_title": "Grant access to restaurant",
   "restaurant_users": "Users with access to the restaurant",
   "restaurant_description_hu": "Restaurant description (hungarian)",
   "restaurant_description_en": "Restaurant description (english)",
   "changes_saved": "Changes were saved successfully",
   "user_added_to_restaurant": "User was granted access to the restaurant",
   "user_add_to_restaurant_tip": "The user with the provided email address will be granted access to the selected restaurant. If the user does not have an account yet, they will automatically receive access after registration.",
   "sign_up_here": "You can create an account here",
   "role_already_exists": "User with this email already has access to the restaurant",
   "error": "Error",
   "header_image": "Header image",
   "upload_image": "Upload image",
   "image_not_set": "Image not set",
   "validation": {
      "required": "This field is required",
      "optional": "This field is optional"
   },
   "hungary": "Magyarország",
   "date": "Date",
   "close": "Close",
   "continue": "Continue",
   "select_image": "Select image",
   "grant": "Grant",
   "restaurant_settings": "Restaurant settings",
   "create_restaurant": "Create restaurant",
   "restaurant_created": "Restaurant created successfully",
   "restaurant_created_text": "Your restaurant has been created successfully. You can now add menu items and manage your restaurant settings.",
   "continue_to_menu": "Continue to menu editing",
   "languages": {
      "hu": "Hungarian",
      "en": "English",
      "de": "German",
      "fr": "French",
      "sk": "Slovak",
      "cz": "Czech",
      "pl": "Polish",
      "si": "Slovenian",
      "hr": "Croatian",
      "ro": "Romanian",
   },
   "no_file_selected": "No file selected",
   "max_file_size": "Maximum file size:",
   "language": "Language",
   "google_analytics": "Google Analytics",
   "facebook_pixel": "Facebook Pixel",
   "analytic_integration_premium_feature": "Analytics integration is a part of the PRO plan",
   "refresh": "Refresh",
   "address": "Address",
   "city": "City",
   "postal_code": "Postal code",
   "timezone": "Timezone",
   "country": "Country",
   "currency": "Currency",
   "currency_tooltip": "This is only required for profile settings, our system will not perform financial transactions on your behalf",
   "or": "or",
   "datachange_detected": "Data change detected",
   "datachange_subtitle": "The menu you are editing has been changed since you loaded the page.",
   "datachange_description": "Would you like to reload the menu and lose your changes, or keep your version and overwrite the other changes?",
   "datachange_refresh": "Reload the page, lose my changes",
   "datachange_overwrite": "Keep my version, overwrite other changes"
}

export default commonEn;